import {
  CREATE_ENTITY_REQUEST,
  CREATE_ENTITY_REQUEST_SUCCESS,
  CREATE_ENTITY_REQUEST_FAILURE,
  SAVE_ENTITY_REQUEST,
  SAVE_ENTITY_REQUEST_SUCCESS,
  SAVE_ENTITY_REQUEST_FAILURE,
  DELETE_ENTITY_REQUEST,
  DELETE_ENTITY_REQUEST_SUCCESS,
  DELETE_ENTITY_REQUEST_FAILURE,
} from '../constants/ActionTypes';

export default function EntityCRUD(state = {}, action) {
  switch (action.type) {
    case CREATE_ENTITY_REQUEST:
      return {
        ...state,
        CRUDLoading: true,
      };
    case CREATE_ENTITY_REQUEST_SUCCESS:
      return {
        ...state,
        CRUDLoading: false,
      };
    case CREATE_ENTITY_REQUEST_FAILURE:
      return {
        ...state,
        CRUDLoading: false,
      };
    case SAVE_ENTITY_REQUEST:
      return {
        ...state,
        CRUDLoading: true,
      };
    case SAVE_ENTITY_REQUEST_SUCCESS:
      return {
        ...state,
        CRUDLoading: false,
      };
    case SAVE_ENTITY_REQUEST_FAILURE:
      return {
        ...state,
        CRUDLoading: false,
      };
    case DELETE_ENTITY_REQUEST:
      return {
        ...state,
        CRUDLoading: true,
      };
    case DELETE_ENTITY_REQUEST_SUCCESS:
      return {
        ...state,
        CRUDLoading: false,
      };
    case DELETE_ENTITY_REQUEST_FAILURE:
      return {
        ...state,
        CRUDLoading: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EntityCRUD.js